import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=5333c05d&scoped=true"
import script from "./FeedbackList.vue?vue&type=script&lang=js"
export * from "./FeedbackList.vue?vue&type=script&lang=js"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=5333c05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5333c05d",
  null
  
)

export default component.exports